export default __webpack_public_path__ + "static/media/services-site-internet.578b4bf2.svg";